const CartClose = ({ style, color = "#1a1a1a" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.754"
      height="23.609"
      viewBox="0 0 31.754 23.609"
      style={style}
    >
      <g
        id="Raggruppa_1279"
        data-name="Raggruppa 1279"
        transform="translate(-515 -453.777)"
      >
        <path
          id="_3507742_cart_ecommerce_grocery_iconoteka_shop_icon"
          data-name="3507742_cart_ecommerce_grocery_iconoteka_shop_icon"
          d="M10.3,27.853a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,10.3,27.853Zm18.194,0a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,28.5,27.853Z"
          transform="translate(514.242 445.734)"
          fill={color}
        />
        <path
          id="Tracciato_141"
          data-name="Tracciato 141"
          d="M-18500-5453.223h4.826l4.186,16.124h20.314"
          transform="translate(19016 5908)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2"
        />
        <path
          id="Tracciato_142"
          data-name="Tracciato 142"
          d="M-18490.082-5440.073l21.67-4.379v-6.587h-23.9"
          transform="translate(19014.166 5907.44)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export default CartClose;
